<div class="progress progress-tscheck" [ngClass]="{'active': active}" (window:mousedown)="activate(true)" (window:mouseup)="activate(false)">
    <div class="progress-bar" role="progress" [ngStyle]="{'width': width, 'background-color': bgColor}">
      <span>{{label}}</span>
    </div>
</div>
